export function measuredYield(raw, cooked, preCook = "") {
  const valid = (v) => String(v).trim() !== "" && Number.isFinite(Number(v)) && Number(v) > 0;
  if (!valid(raw) || !valid(cooked)) return null;
  return {
    rawPct: Number(cooked) / Number(raw) * 100,
    cookPct: valid(preCook) ? Number(cooked) / Number(preCook) * 100 : null,
    loss: valid(preCook) ? Number(preCook) - Number(cooked) : null,
  };
}
